import { IVatTuResponseBase } from '@/core/interfaces/ApiResponses';
import { VatTuService } from '@/core/services/VatTu.service';
import { getErrorMsg, swalNotification } from '@/core/helpers/utils';

const useVatTu = () => {
  const isValidItems = (vatTuArr: IVatTuResponseBase[]) => {
    return vatTuArr.map(({ is_valid }) => is_valid === 1);
  };

  const isValid = (vatTu: IVatTuResponseBase) => vatTu?.is_valid === 1;

  const isTextDangerColumn = ({ row }: { row: IVatTuResponseBase }) =>
    row?.is_valid === 0 ? 'text-danger' : '';

  const isValidLabel = (vatTu: IVatTuResponseBase) => {
    if (vatTu?.is_valid === 1) return 'Hợp lệ';

    return 'Chờ phê duyệt';
  };

  const duyetVatTu = async ({ vatTu }: { vatTu: IVatTuResponseBase }) => {
    try {
      await VatTuService.approve(vatTu.id);

      swalNotification('Vật tư được duyệt thành công', 'success');
    } catch (e) {
      await swalNotification(
        getErrorMsg(e, 'Có lỗi, không thể duyệt vật tư này'),
        'error'
      );

      throw e;
    }
  };

  return {
    duyetVatTu,
    isValid,
    isTextDangerColumn,
    isValidItems,
    isValidLabel,
  };
};

export default useVatTu;
